export enum AppType {
  PRENUP = "PRENUP",
  POSTNUP = "POSTNUP",
}

export enum Environment {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
}

const viteEnv = import.meta.env as unknown as Record<
  string,
  string | undefined
>;

export const getViteEnv = (key: string): string | undefined => {
  return viteEnv[key];
};

const getAppType = (): AppType => {
  const configuredAppType = getViteEnv("VITE_APP_TYPE");
  if (
    configuredAppType === AppType.PRENUP ||
    configuredAppType === AppType.POSTNUP
  ) {
    return configuredAppType;
  }

  const hostname = window.location.hostname;
  const port = window.location.port;
  if (hostname === "localhost" && port === "5174") return AppType.POSTNUP;
  if (hostname.includes("postnup")) return AppType.POSTNUP;
  return AppType.PRENUP;
};

const getConfig = () => {
  const hostname = window.location.hostname;
  const appType = getAppType();

  if (hostname === "localhost") {
    const prenupTemplateId = "01999158-f1c9-7c52-82df-7c5734634623";
    const postnupTemplateId = "019cb045-1dbe-7222-9bb3-1d853e4b9d92";
    const prenupClerkKey =
      "pk_test_ZGV2b3RlZC1sYWR5YnVnLTY5LmNsZXJrLmFjY291bnRzLmRldiQ";
    const postnupClerkKey =
      "pk_test_d2lubmluZy1rb2ktMzMuY2xlcmsuYWNjb3VudHMuZGV2JA";
    return {
      appType,
      api: getViteEnv("VITE_API_BASE_URL") ?? "http://localhost:3000",
      clerkKey: appType === AppType.POSTNUP ? postnupClerkKey : prenupClerkKey,
      prenupTemplateId,
      postnupTemplateId,
      templateId:
        appType === AppType.POSTNUP ? postnupTemplateId : prenupTemplateId,
      weddingDateQuestionId: "01999159-508b-7531-a868-ba2d9cb7dabd",
      postnupMarriageDateQuestionId: "019cfd1d-03be-7011-bece-945c94040f9d",
      postnupIntentToDivorceOptionId: "019cfd1d-03b3-77e2-8e02-de5975388ba9",
      postnupHasPrenupOptionId: "019cfd1d-0355-7ea3-9e48-64e57bd57c00",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b",
      sentryDsn:
        "https://eba852d63fff2c6cc808442e5107a11e@o910650.ingest.us.sentry.io/4509707936727040",
      environment: Environment.DEVELOPMENT,
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
      rudderStackWriteKey: "37tsIz67IA9AEBCvQ0TuHnqXXqP",
      rudderStackDataPlaneUrl:
        "https://helloprenunzug.dataplane.rudderstack.com",
    };
  }

  if (
    hostname === "staging.helloprenup.com" ||
    hostname === "staging.postnup.com"
  ) {
    const prenupTemplateId = "01999158-f1c9-7c52-82df-7c5734634623";
    const postnupTemplateId = "019cb045-1dbe-7222-9bb3-1d853e4b9d92";
    const prenupClerkKey = "pk_live_Y2xlcmsuc3RhZ2luZy5oZWxsb3ByZW51cC5jb20k";
    const postnupClerkKey = "pk_live_Y2xlcmsuc3RhZ2luZy5wb3N0bnVwLmNvbSQ";
    return {
      appType,
      api:
        appType === AppType.POSTNUP
          ? "https://api.staging.postnup.com"
          : "https://api.staging.helloprenup.com",
      clerkKey: appType === AppType.POSTNUP ? postnupClerkKey : prenupClerkKey,
      prenupTemplateId,
      postnupTemplateId,
      templateId:
        appType === AppType.POSTNUP ? postnupTemplateId : prenupTemplateId,
      weddingDateQuestionId: "01999159-508b-7531-a868-ba2d9cb7dabd",
      postnupMarriageDateQuestionId: "019cfd1d-03be-7011-bece-945c94040f9d",
      postnupIntentToDivorceOptionId: "019cfd1d-03b3-77e2-8e02-de5975388ba9",
      postnupHasPrenupOptionId: "019cfd1d-0355-7ea3-9e48-64e57bd57c00",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b",
      sentryDsn:
        "https://5c3f457c0180140c7e5a8665150d3fde@o910650.ingest.us.sentry.io/4510077374431232",
      environment: Environment.STAGING,
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
      rudderStackWriteKey: "37iMNYpWG2U0wcHJzuShiMmzOdx",
      rudderStackDataPlaneUrl:
        "https://helloprenunzug.dataplane.rudderstack.com",
    };
  }

  if (hostname === "dev.helloprenup.com" || hostname === "dev.postnup.com") {
    const prenupTemplateId = "0198c393-066e-7f21-ac06-d3c635c30e6f";
    const postnupTemplateId = "019d7334-2005-77d1-9bf0-0b02a2df9fbb";
    const prenupClerkKey =
      "pk_test_ZGV2b3RlZC1sYWR5YnVnLTY5LmNsZXJrLmFjY291bnRzLmRldiQ";
    const postnupClerkKey =
      "pk_test_d2lubmluZy1rb2ktMzMuY2xlcmsuYWNjb3VudHMuZGV2JA";
    return {
      appType,
      api:
        appType === AppType.POSTNUP
          ? "https://api.dev.postnup.com"
          : "https://iicbdan22d.execute-api.us-west-2.amazonaws.com",
      clerkKey: appType === AppType.POSTNUP ? postnupClerkKey : prenupClerkKey,
      prenupTemplateId,
      postnupTemplateId,
      templateId:
        appType === AppType.POSTNUP ? postnupTemplateId : prenupTemplateId,
      weddingDateQuestionId: "0198c39c-cdcc-7c52-a88b-77035f7aee34",
      postnupMarriageDateQuestionId: "019d73d4-654f-7ca3-ab51-e64422d0576e",
      postnupIntentToDivorceOptionId: "019d73d4-618c-7621-85d4-8fc357c80f54",
      postnupHasPrenupOptionId: "019d73d4-33e3-7b02-b4d6-84b49c088488",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b",
      sentryDsn:
        "https://eba852d63fff2c6cc808442e5107a11e@o910650.ingest.us.sentry.io/4509707936727040",
      environment: Environment.DEVELOPMENT,
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
      rudderStackWriteKey: "37tsIz67IA9AEBCvQ0TuHnqXXqP",
      rudderStackDataPlaneUrl:
        "https://helloprenunzug.dataplane.rudderstack.com",
    };
  }

  // Production (app.helloprenup.com / app.postnup.com)
  const prenupTemplateId = "01999ec1-488c-7d20-9d51-debc5fed5254";
  const postnupTemplateId = "019cb052-eff0-7bf2-9c62-65bd13195992";
  const prenupClerkKey = "pk_live_Y2xlcmsuaGVsbG9wcmVudXAuY29tJA";
  const postnupClerkKey = "pk_live_Y2xlcmsucG9zdG51cC5jb20k";
  return {
    appType,
    api:
      appType === AppType.POSTNUP
        ? "https://api.postnup.com"
        : "https://api.helloprenup.com",
    clerkKey: appType === AppType.POSTNUP ? postnupClerkKey : prenupClerkKey,
    prenupTemplateId,
    postnupTemplateId,
    templateId:
      appType === AppType.POSTNUP ? postnupTemplateId : prenupTemplateId,
    weddingDateQuestionId: "01999ec7-3f8f-7ab3-b2ba-59bbc33c4b03",
    postnupMarriageDateQuestionId: "019cfda8-43f5-7002-8248-7067250b5760",
    postnupIntentToDivorceOptionId: "019cfda8-43ea-77b2-b074-97c5fcbf923c",
    postnupHasPrenupOptionId: "019cfda8-43a5-75f2-8b53-6dfd589059ef",
    googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
    liveSessionTrackId: "1e410e7f.852d3c21",
    sentryDsn:
      "https://5c3f457c0180140c7e5a8665150d3fde@o910650.ingest.us.sentry.io/4510077374431232",
    environment: Environment.PRODUCTION,
    defaultStateFDVideo: "CA",
    intercomAppId: "seizs4ey",
    rudderStackWriteKey: "37yrMpeN8vFsiO0mwQlFRxvP1bf",
    rudderStackDataPlaneUrl: "https://helloprenuwnsp.dataplane.rudderstack.com",
  };
};

const config = getConfig();

// Impact config
declare global {
  interface Window {
    ire?: {
      (
        action: "identify",
        payload: {
          customerId?: string;
          customerEmail?: string;
          customProfileId?: string;
          [key: string]: unknown;
        },
      ): void;
      (
        action: "trackConversion",
        actionTrackerId: number | string,
        payload: {
          orderId: string;
          customProfileId?: string;
          customerId?: string;
          customerEmail?: string;
          customerStatus?: string;
          currencyCode?: string;
          orderPromoCode?: string;
          orderDiscount?: number;
          items?: {
            subTotal: number;
            category: string;
            sku: string;
            quantity: number;
            name?: string;
            subCategory?: string;
            totalDiscount?: number;
            totalRebate?: number;
          }[];
          [key: string]: unknown;
        },
        options?: {
          verifySiteDefinitionMatch?: boolean;
          [key: string]: unknown;
        },
      ): void;
    };
    _rwq: unknown[];
    rewardful?: (methodName: string, ...args: unknown[]) => void;
    Rewardful?: Rewardful;
  }
  interface Rewardful {
    referral: string | null;
  }
}

export default config;
